const MENU_ITEM_ICON_SIZE = 24
const SECONDARY_MENU_ITEM_ICON_SIZE = 20

export { MENU_ITEM_ICON_SIZE, SECONDARY_MENU_ITEM_ICON_SIZE }
